import { Switch, Tip, useTip } from '@makyoapp/makyo-ui'

import { useSortableTreeContext } from '../contexts/SortableTreeContext'

const TreeControl = () => {
  const { handleCollapseAll, handleExpandAll, flattenedItems } = useSortableTreeContext()

  const isSomeCollapsed = flattenedItems.find((item) => !!item.children.length && item.collapsed)
  const isAllExpanded = !isSomeCollapsed

  const handleToggleExpandCollapse = () => {
    if (isAllExpanded) {
      handleCollapseAll()
    } else {
      handleExpandAll()
    }
  }

  const {
    x,
    y,
    strategy,
    refs,
    context,
    placement,
    isOpen: isTipOpen,
    arrowRef,
    getReferenceProps,
    getFloatingProps,
  } = useTip()

  return (
    <>
      <div ref={refs.setReference} className='flex gap-2 w-max h-max items-center' {...getReferenceProps()}>
        <label className='capitalize'>Expand</label>
        <Switch id='expand-collapse-checkbox' checked={isAllExpanded} onClick={handleToggleExpandCollapse} />
      </div>

      {isTipOpen && (
        <Tip
          className='max-w-[300px] text-m-sm !px-2.5'
          x={x}
          y={y}
          placement={placement}
          strategy={strategy}
          ref={refs.setFloating}
          {...getFloatingProps()}
          context={context as any}
          arrowRef={arrowRef}
        >
          {isAllExpanded ? 'Collapse all elements' : 'Expand all elements'}
        </Tip>
      )}
    </>
  )
}

export default TreeControl
